import React, { useState } from 'react';
import { Formik } from 'formik';
import { ADD_CORROSION_LOG_FORM_FEILDS } from 'features/wells/corrosion/helpers/corrosionlogs.constants';
import { Grid, Drawer, Button } from '@material-ui/core';
import withStyles from '@material-ui/styles/withStyles';
import moment from 'moment';
import AddLogFilesDrawerTemplateSection from 'features/wells/corrosion/components/AddLogFilesDrawerTemplateSection';
import AddLogFilesDrawerUploadSection from 'features/wells/corrosion/components/AddLogFilesDrawerUploadSection';
import { Divider } from '@material-ui/core/';
import { getAddLogFileFormSchema } from 'features/wells/corrosion/helpers/corrosionlogs.utils';

import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  loadCorrosionLogTemplate,
  loadCorrosionMeasureTools,
  loadServiceProviders,
  createNewServiceProvider,
  createNewCorrosionMeasureTool,
  createNewCorrosionLog,
} from 'features/wells/corrosion/helpers/corrosionlogs.actions';
import {
  selectCorrosionMeasureTools,
  selectServiceProvider,
  selectNewServiceProvider,
  selectNewCorrosionMeasureTool,
} from 'features/wells/corrosion/helpers/corrosionlogs.selectors';

import AddLogFileFormFields from 'features/wells/corrosion/components/AddLogFileFormFields';
import { useEffect } from 'react';

const AddLogFileDrawer = ({
  isOpen,
  toggleDrawer,
  classes,
  dispatchLoadTemplate,
  disptachLoadCorrosionMeasureTool,
  dispatchLoadServiceProviders,
  tools,
  serviceProviders,
  // dispatchCreteNewServiceProvider,
  // dispatchCreateNewCorrosionMeasureTool,
  // logServiceProvider,
  // corrosionMeasureTool,
  externalWellboreId,
  dispatchCreateNewCorrosionLog,
}) => {
  const [initialAddLogFormValues, setInitialAddLogFormValues] = useState({
    [ADD_CORROSION_LOG_FORM_FEILDS.FILE_NAME]: '',
    [ADD_CORROSION_LOG_FORM_FEILDS.LOG_DATE]: '',
    [ADD_CORROSION_LOG_FORM_FEILDS.SERVICE_PROVIDER]: '',
    [ADD_CORROSION_LOG_FORM_FEILDS.TOOL]: '',
  });

  // const [newCorrosionMeasureToolFlag, setNewCorrosionMeasureToolFlag] = useState(false);
  // const [newServiceProviderFlag, setNewServiceProviderFlag] = useState(false);

  // const [pendingLogData, setPendingLogData] = useState(null);
  // const [isSubmissionPending, setIsSubmissionPending] = useState(false);

  const [uploadedFiles, setUploadedFiles] = useState([]);

  useEffect(() => {
    dispatchLoadServiceProviders();
    disptachLoadCorrosionMeasureTool();
  }, [dispatchLoadServiceProviders, disptachLoadCorrosionMeasureTool]);

  useEffect(() => {
    setInitialAddLogFormValues((prevValues) => ({
      ...prevValues,
      [ADD_CORROSION_LOG_FORM_FEILDS.FILE_NAME]:
        uploadedFiles.length > 0 ? uploadedFiles[0]?.name : '',
    }));
  }, [uploadedFiles]);

  // const handleCreateCorrosionMeasureTool = async (toolValue) => {
  //   await dispatchCreateNewCorrosionMeasureTool(toolValue);
  // };

  // const handleCreateServiceProvider = async (spValue) => {
  //   await dispatchCreteNewServiceProvider(spValue);
  // };

  const addNewLog = async (values) => {
    // setPendingLogData(values);
    // setIsSubmissionPending(true);
    const logPayload = {
      file: uploadedFiles.length > 0 ? uploadedFiles[0] : {},
      [ADD_CORROSION_LOG_FORM_FEILDS.FILE_NAME]:
        values[ADD_CORROSION_LOG_FORM_FEILDS.FILE_NAME],
      [ADD_CORROSION_LOG_FORM_FEILDS.LOG_DATE]: moment(
        values[ADD_CORROSION_LOG_FORM_FEILDS.LOG_DATE],
      ).toISOString(),
      [ADD_CORROSION_LOG_FORM_FEILDS.SERVICE_PROVIDER]:
        values[ADD_CORROSION_LOG_FORM_FEILDS.SERVICE_PROVIDER],
      [ADD_CORROSION_LOG_FORM_FEILDS.TOOL]:
        values[ADD_CORROSION_LOG_FORM_FEILDS.TOOL],
      wellId: externalWellboreId,
    };

    dispatchCreateNewCorrosionLog(
      uploadedFiles.length > 0 ? uploadedFiles[0] : {},
      logPayload,
      toggleDrawer,
    );
  };

  // COMMENTED THE FUNCTIONALITY TO CREATE OR SELECT Service Provider or Tools

  // useEffect(() => {
  //   if (isSubmissionPending && pendingLogData) {
  //     const toolValue = pendingLogData[ADD_CORROSION_LOG_FORM_FEILDS.TOOL];
  //     const spValue = pendingLogData[ADD_CORROSION_LOG_FORM_FEILDS.SERVICE_PROVIDER];

  //     if (newCorrosionMeasureToolFlag) {
  //       handleCreateCorrosionMeasureTool(toolValue);
  //     }
  //     if (newServiceProviderFlag) {
  //       handleCreateServiceProvider(spValue);
  //     }

  //     if (!newCorrosionMeasureToolFlag && !newServiceProviderFlag) {

  //       const logPayload = {

  //         [ADD_CORROSION_LOG_FORM_FEILDS.FILE_NAME]: pendingLogData[ADD_CORROSION_LOG_FORM_FEILDS.FILE_NAME],
  //         [ADD_CORROSION_LOG_FORM_FEILDS.LOG_DATE]: moment(pendingLogData[ADD_CORROSION_LOG_FORM_FEILDS.LOG_DATE]).toISOString(),
  //         [ADD_CORROSION_LOG_FORM_FEILDS.SERVICE_PROVIDER]: spValue,
  //         [ADD_CORROSION_LOG_FORM_FEILDS.TOOL]: toolValue,
  //         categoryId: 1,
  //         fileStorage: 0,
  //         wellId: externalWellboreId,
  //       };

  //       dispatchCreateNewCorrosionLog(uploadedFiles.length > 0 ? uploadedFiles[0] : {}, logPayload)
  //       setIsSubmissionPending(false);
  //       setPendingLogData(null);
  //     }
  //   }
  // }, [
  //   isSubmissionPending,
  //   pendingLogData,
  //   newCorrosionMeasureToolFlag,
  //   newServiceProviderFlag,
  // ]);

  // useEffect(() => {
  //   if (isSubmissionPending && pendingLogData) {

  //     let ready = true;
  //     let finalToolId = pendingLogData[ADD_CORROSION_LOG_FORM_FEILDS.TOOL];
  //     let finalServiceProviderId = pendingLogData[ADD_CORROSION_LOG_FORM_FEILDS.SERVICE_PROVIDER];

  //     if (newCorrosionMeasureToolFlag) {
  //       if (corrosionMeasureTool && corrosionMeasureTool.corrosionMeasureToolId) {
  //         finalToolId = corrosionMeasureTool.corrosionMeasureToolId;
  //       } else {
  //         ready = false;
  //       }
  //     }
  //     if (newServiceProviderFlag) {
  //       if (logServiceProvider && logServiceProvider.serviceProviderId) {
  //         finalServiceProviderId = logServiceProvider.serviceProviderId;
  //       } else {
  //         ready = false;
  //       }
  //     }

  //     if (ready) {
  //       const logPayload = {

  //         [ADD_CORROSION_LOG_FORM_FEILDS.FILE_NAME]: pendingLogData[ADD_CORROSION_LOG_FORM_FEILDS.FILE_NAME],
  //         [ADD_CORROSION_LOG_FORM_FEILDS.LOG_DATE]: moment(pendingLogData[ADD_CORROSION_LOG_FORM_FEILDS.LOG_DATE]).toISOString(),
  //         [ADD_CORROSION_LOG_FORM_FEILDS.SERVICE_PROVIDER]: finalServiceProviderId,
  //         [ADD_CORROSION_LOG_FORM_FEILDS.TOOL]: finalToolId,
  //         categoryId: 1,
  //         fileStorage: 0,
  //         wellId: externalWellboreId,
  //       };

  //       dispatchCreateNewCorrosionLog(uploadedFiles.length > 0 ? uploadedFiles[0] : {}, logPayload)

  //       setIsSubmissionPending(false);
  //       setPendingLogData(null);
  //     }
  //   }
  // }, [
  //   isSubmissionPending,
  //   pendingLogData,
  //   corrosionMeasureTool,
  //   logServiceProvider,
  //   newCorrosionMeasureToolFlag,
  //   newServiceProviderFlag,
  // ]);

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={toggleDrawer}
      classes={{ paper: classes.drawerPaper }}
    >
      <Formik
        enableReinitialize
        onSubmit={(values) => addNewLog(values)}
        initialValues={initialAddLogFormValues ?? {}}
        validationSchema={getAddLogFileFormSchema()}
      >
        {({ handleSubmit, dirty }) => (
          <form onSubmit={handleSubmit}>
            <Grid item className={classes.mainContainer}>
              <Grid item className={classes.sectionContainer}>
                <AddLogFilesDrawerTemplateSection
                  downloadTemplate={dispatchLoadTemplate}
                />
              </Grid>
              <Divider />
              <Grid item className={classes.sectionContainer}>
                <AddLogFilesDrawerUploadSection
                  setUploadedFiles={setUploadedFiles}
                  uploadedFiles={uploadedFiles}
                />
                {uploadedFiles.length > 0 && (
                  <Grid container className={classes.addLogForm}>
                    <AddLogFileFormFields
                      initialValues={initialAddLogFormValues}
                      tools={tools}
                      serviceProviders={serviceProviders}
                      // createNewCorrosionMeasureTool={(value) =>
                      //   setNewCorrosionMeasureToolFlag(value)
                      // }
                      // createNewServiceProvider={(value) =>
                      //   setNewServiceProviderFlag(value)
                      // }
                    />
                  </Grid>
                )}
              </Grid>
              <Grid item className={classes.drawerFooter}>
                <Button
                  title="Cancel"
                  color="secondary"
                  variant="text"
                  type="button"
                  className={classes.drawerButton}
                  onClick={toggleDrawer}
                  size="large"
                >
                  Cancel
                </Button>
                <Button
                  title="Save"
                  color="primary"
                  variant="contained"
                  type="submit"
                  className={classes.drawerButton}
                  size="large"
                  disabled={!dirty}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </Drawer>
  );
};

const styles = (theme) => ({
  drawerPaper: {
    width: '30%',
    minWidth: 300,
    background: theme.palette.background.default,
  },
  circularProgress: {
    display: 'flex',
    justifyContent: 'center',
  },
  sectionContainer: {
    padding: theme.spacing(2),
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  drawerFooter: {
    position: 'fixed',
    bottom: 0,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
    right: 0,
    backgroundColor: theme.palette.secondary.dark,
    width: '30%',
  },
  drawerButton: {
    margin: theme.spacing(2),
    color: theme.palette.common.white,
  },
  addLogForm: {
    display: 'flex',
    alignItems: 'left',
    marginTop: theme.spacing(2),
  },
});

export default compose(
  connect(
    (state) => ({
      tools: selectCorrosionMeasureTools(state),
      serviceProviders: selectServiceProvider(state),
      logServiceProvider: selectNewServiceProvider(state),
      corrosionMeasureTool: selectNewCorrosionMeasureTool(state),
    }),
    {
      dispatchLoadTemplate: loadCorrosionLogTemplate,
      disptachLoadCorrosionMeasureTool: loadCorrosionMeasureTools,
      dispatchLoadServiceProviders: loadServiceProviders,
      dispatchCreteNewServiceProvider: createNewServiceProvider,
      dispatchCreateNewCorrosionMeasureTool: createNewCorrosionMeasureTool,
      dispatchCreateNewCorrosionLog: createNewCorrosionLog,
    },
  ),
  withStyles(styles),
)(AddLogFileDrawer);
